import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAssessmentBuilderStore = defineStore('assessmentBuilder', () => {
    const activeBlock = ref(null);
    const droppedBlocks = ref([]);

    // actions
    // MoveBlockUp and down isnt used anymore but still not removed Just incase it might be useful in future
    const moveBlockUp = (index) => {
        const currentBlock = droppedBlocks.value[index];
        const previousBlock = droppedBlocks.value[index - 1];
        droppedBlocks.value.splice(index - 1, 2, currentBlock, previousBlock);
    };

    const moveBlockDown = (index) => {
        const currentBlock = droppedBlocks.value[index];
        const nextBlock = droppedBlocks.value[index + 1];
        droppedBlocks.value?.splice(index, 2, nextBlock, currentBlock);
    };

    const removeBlock = (index) => {
        droppedBlocks.value?.splice(index, 1);
        setActiveBlock();
    };

    const setActiveBlock = (block = null) => {
        activeBlock.value = block;
    };

    const setExistingBlocks = (blocks) => {
        droppedBlocks.value = blocks;
    };

    return {
        // states
        activeBlock,
        droppedBlocks,
        // actions
        moveBlockUp,
        moveBlockDown,
        removeBlock,
        setActiveBlock,
        setExistingBlocks,
    };
});
